import BaseModel from './BaseModel';

export default class ReferenceTermHighlights extends BaseModel {
  constructor(data = {}) {
    super(ReferenceTermHighlights, data);
    this.referenceId = data.referenceId;
    this.matches = data.matches;
  }
}
